import { Observable } from 'rxjs';
import { System } from 'common/systems/domain/resources/system.resource';

/**
 * Real-time-updates port for the `systems` capability. Implementations
 * live in infrastructure (e.g. wrapping the existing websocket
 * infrastructure over the `'systems'` public channel); `common/`
 * consumers must depend only on this abstract class, never on a concrete
 * socket infrastructure or on Angular.
 */
export abstract class SystemsRealtimePort {
    public abstract onSystemsUpdated(): Observable<ReadonlyArray<System>>;
}
